const getEspots = (espotContent) => new Map(
  espotContent.map((espot) => [
    espot.espotId,
    { htmlContent: espot.htmlContent, timestamp: espot.timestamp },
  ]),
);

export default getEspots;
